import { render } from "./InvoiceDetailsPriceTable.vue?vue&type=template&id=31edf44c&scoped=true"
import script from "./InvoiceDetailsPriceTable.vue?vue&type=script&lang=js"
export * from "./InvoiceDetailsPriceTable.vue?vue&type=script&lang=js"

import "./InvoiceDetailsPriceTable.vue?vue&type=style&index=0&id=31edf44c&lang=scss&scoped=true"

import exportComponent from "H:\\_LK\\workInProgress\\invoice-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31edf44c"]])

export default __exports__